import React, { ButtonHTMLAttributes } from 'react';
import { FaPlus } from 'react-icons/fa';

import { Container } from './styles';

interface IAddAltProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  processing?: boolean;
}

const AddAlt: React.FC<IAddAltProps> = ({ ...rest }) => {
  return (
    <Container {...rest} type="button">
      Adicionar
      <FaPlus size={16} />
    </Container>
  );
};

export default AddAlt;
